import { createApi } from "@corecrm/ui";

export const API_BASE = "/portal/api/v1";

let unauthenticated: () => void = () => {};

/** What to do when the session is missing or has expired (set once, in main.tsx). */
export function onUnauthenticated(handler: () => void) {
  unauthenticated = handler;
}

export const api = createApi({ baseUrl: API_BASE, onUnauthenticated: () => unauthenticated() });

/** A same-origin link to a file the API serves (quote PDFs, rate cards, deliverable files). The
    session cookie authorizes it, so a plain link opens it in the browser's own viewer. */
export function fileUrl(path: string, download = false) {
  return `${API_BASE}${path}${download ? "?download=true" : ""}`;
}
